import localeRouting from '@/config/localeRouting.json';

/**
 * Pages that should always use English (no localized versions).
 * Single source of truth: config/localeRouting.json
 * Used by middleware for redirects and by HreflangTags to avoid invalid alternate URLs.
 */
export const NON_LOCALIZED_PAGES: readonly string[] =
	localeRouting.nonLocalizedPages;
export const NON_LOCALIZED_PAGES_SET = new Set<string>(NON_LOCALIZED_PAGES);
